import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteToggleButton from '@/components/shared/favoritos/FavoriteToggleButton';

const CustomModal = ({
    open,
    onClose,
    title,
    children,
    width = '96%',
    maxWidth = 'xs',
    fullWidth = true,
    showCloseIcon = true,
    hideHeader = false,
    hideFooter = false,
    actions = null,
    dialogProps = {},
    paperSx = {},
    contentSx = {},
    hidePadding = false,
    padding = 2,
    playerId = null,
    customHeader = null,
    headerStyles = {},
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            {...dialogProps}
            slotProps={{
                paper: {
                    sx: {
                        maxWidth: 600,
                        width,
                        m: '2%',
                        borderRadius: 2,
                        bgcolor: 'background.default',
                        border: `1px solid`,
                        borderColor: 'border.main',
                        position: 'relative',
                        '&:before': {
                            content: '""',
                            position: 'absolute',
                            inset: 0,
                            height: '3px',
                            background:
                                'linear-gradient(90deg, #69b59f 0%, rgba(105, 181, 159, 0.25) 60%, transparent 100%)',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            pointerEvents: 'none',
                            zIndex: 1,
                        },
                        ...paperSx,

                        ...(hidePadding && {
                            '& .MuiDialogContent-root': {
                                padding: 0.5,
                            },
                        }),
                    },
                },
            }}
        >
            {!hideHeader && (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        borderBottom: `1px solid`,
                        borderColor: 'border.main',
                        px: padding,
                        bgcolor: 'background.darkCard',
                        height: '40px',
                        ...headerStyles,
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <DialogTitle sx={{ p: 0, fontSize: '16px', background: 'none' }}>{title}</DialogTitle>
                        {playerId > 0 && <FavoriteToggleButton playerId={playerId} />}
                    </Box>
                    {showCloseIcon && (
                        <IconButton onClick={onClose}>
                            <CloseIcon sx={{ color: 'text.primary' }} />
                        </IconButton>
                    )}
                </Box>
            )}

            {customHeader}

            <DialogContent sx={{ pt: padding, px: padding, ...contentSx }}>{children}</DialogContent>

            {!hideFooter && actions && (
                <DialogActions sx={{ px: padding, pb: padding }}>{actions}</DialogActions>
            )}
        </Dialog>
    );
};

export default CustomModal;
